import React from 'react';
import { Field } from 'react-final-form';

import { WpContainer, WpContainerHeader, WpContainerBody } from 'Wpds/components/container';
import FormTextarea from 'Shared/components/FormComponents/FormTextarea';
import { FormVideoInput } from 'Dashboard/components/VideoInput/VideoInput';
import WpIcon from 'Wpds/components/icon/WpIcon';
import WpButton from 'Wpds/components/button/WpButton';
import { clickedFeedbackFormEvent } from 'Shared/constants/constants';

import './FeedbackFormFieldContainer.scss';

// Hooks
import { useApp } from 'Shared/utils/hooks/use-app';

type Props = {
  title: string;
  textFieldName: string;
  videoFieldName?: string;
  templateType: string;
  initialValue?: string;
  rows?: number;
};

function FeedbackFormFieldContainer({ title, textFieldName, videoFieldName, templateType, rows = 4 }: Props) {
  const { isZoom } = useApp();

  const handleClick = onClickFunc => {
    (window as any).analytics.track(clickedFeedbackFormEvent, { target: 'add_video_button', templateType });
    onClickFunc();
  };

  return (
    <WpContainer>
      <WpContainerHeader>
        <div className="FeedbackFormFieldContainer__title">{title}</div>
      </WpContainerHeader>
      <WpContainerBody>
        <Field
          name={textFieldName}
          rows={rows}
          textareaClassName="FeedbackFormFieldContainer__textarea"
          placeholder="Leave your thoughtful feedback here"
          component={FormTextarea}
        />
        {videoFieldName && (
          <div className="FeedbackFormFieldContainer__video">
            <Field name={videoFieldName}>
              {({ input: { onChange, value } }) => (
                <FormVideoInput
                  value={value}
                  onChange={onChange}
                  switchButton={({ onClick }) =>
                    !isZoom && (
                      <WpButton icon variant="tertiary" onClick={() => handleClick(onClick)}>
                        <WpIcon name="video-plus" />
                        Add a video recording
                      </WpButton>
                    )
                  }
                />
              )}
            </Field>
          </div>
        )}
      </WpContainerBody>
    </WpContainer>
  );
}

export default FeedbackFormFieldContainer;
